import { functions } from "@/firebase";

// Members-only images of a section (topos, camera photos). The Firestore docs keep only Storage paths and Storage
// gives no direct read access: the getSectionMedia Cloud Function (functions/includes/mediaFunctions.js) checks the
// caller (member, admin, or anyone on a free section) and returns signed URLs that expire after a few hours.
async function getSectionMedia(sectionId, kind) {
  if (!sectionId) return [];
  const response = await functions.httpsCallable("getSectionMedia")({ sectionId, kind });
  return response.data || {};
}

export const SectionMediaService = {
  // [{ url, path, fileName, description }]
  async getTopos(sectionId) {
    return (await getSectionMedia(sectionId, "topos")).topos || [];
  },
  // [{ id, taken_at (ms), url }], newest first
  async getCameraPhotos(sectionId) {
    return (await getSectionMedia(sectionId, "camera")).photos || [];
  },
};
